import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';

const TrialBanner = ({ daysRemaining, salesPageUrl }) => {
  const urgencyColor = daysRemaining <= 2 ? 'bg-red-500/20 border-red-500/30 text-red-200' 
    : daysRemaining <= 4 ? 'bg-amber-500/20 border-amber-500/30 text-amber-200'
    : 'bg-[#EFB342]/20 border-[#EFB342]/30 text-[#EFB342]';

  const urgencyText = daysRemaining <= 1 
    ? "Last day!" 
    : daysRemaining <= 2 
      ? "Only 2 days left!" 
      : `${daysRemaining} days left`;

  return (
    <div className={`rounded-xl border p-4 mb-4 ${urgencyColor}`} data-testid="trial-banner">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-3">
          <Clock size={20} className="flex-shrink-0" />
          <div>
            <p className="font-semibold text-sm">
              Free Trial: <span className="font-bold">{urgencyText}</span>
            </p>
            <p className="text-xs opacity-80">
              Your points will be saved when you sign up for full access!
            </p>
          </div>
        </div>
        <a
          href={salesPageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap"
          data-testid="trial-banner-cta"
        >
          Get Full Access
          <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
};

export default TrialBanner;
